import React, { Component } from 'react';

import {
    Alert
} from 'design-react-kit';

export class BoxSuccess extends Component {

    render() {
        return (
            <>
                <Alert color="success" tag="div" {...this.props}  >
                    {this.props.children}
                </Alert>
            </>
        )
    }
}